import { SEARCH_BASE_URL, POPULAR_BASE_URL, IMAGE_BASE_URL } from './config';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

// Build a proxied TMDB URL through our backend
const tmdb = (path, params = {}) => {
  const qs = new URLSearchParams({ path, language: 'en-US', ...params }).toString();
  return `${BACKEND_URL}/tmdb?${qs}`;
};

// ─── Adult-content helpers ────────────────────────────────────────────────────
// Read preference and token from localStorage so non-React code can access them.
// The backend will independently verify the JWT before allowing adult=true.
const isAdultEnabled = () => localStorage.getItem('adultContent') === 'true';
const getAuthHeaders = () => {
  const token = localStorage.getItem('userToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const apiSettings = {
  fetchMovies: async (searchTerm, page) => {
    const adult = isAdultEnabled() ? 'true' : 'false';
    const endpoint = searchTerm
      ? SEARCH_BASE_URL(searchTerm) + `&page=${page}&include_adult=${adult}`
      : POPULAR_BASE_URL + `&page=${page}&include_adult=${adult}`;
    const response = await fetch(endpoint, { headers: getAuthHeaders() });
    return await response.json();
  },

  fetchMovie: async (movieId) => {
    const endpoint = tmdb(`movie/${movieId}`, { append_to_response: 'credits' });
    return await (await fetch(endpoint, { headers: getAuthHeaders() })).json();
  },

  fetchCredits: async (movieId) => {
    const endpoint = tmdb(`movie/${movieId}/credits`);
    return await (await fetch(endpoint, { headers: getAuthHeaders() })).json();
  },

  fetchActor: async (actorId) => {
    const endpoint = tmdb(`person/${actorId}`);
    return await (await fetch(endpoint, { headers: getAuthHeaders() })).json();
  },

  fetchActorCredits: async (actorId) => {
    const endpoint = tmdb(`person/${actorId}/movie_credits`);
    return await (await fetch(endpoint, { headers: getAuthHeaders() })).json();
  },
};

export default apiSettings;

// Keep IMAGE_BASE_URL accessible for any direct image usage
export { IMAGE_BASE_URL };